export const initialValues = (
  wholesaler: IWholesalerAddInfo | undefined,
  state: IOption | undefined,
  city: IOption | undefined,
) => {
  return {
    title: wholesaler?.title ? wholesaler?.title : '',
    description: wholesaler?.description ? wholesaler?.description : '',
    state: wholesaler?.state
      ? wholesaler?.state
      : state
      ? `${state.value}`
      : '',
    city: wholesaler?.city ? wholesaler?.city : city ? `${city.value}` : '',
    hide_phone_number: wholesaler?.hide_phone_number
      ? wholesaler?.hide_phone_number
      : false,
  };
};
